export default {
  title: 'Juomarahan asetukset',
  form: {
    has_tips: {
      label: 'Salli juomarahat',
    },
    default_tip_percentage: {
      label: 'Esivalittu juomarahaprosentti',
      tooltip: 'Tämä on prosenttiosuus, joka valitaan asiakkaalle valmiiksi, kun hän siirtyy maksunäyttöön',
    },
    is_tip_hidden_on_receipt: {
      label: 'Juomarahat eivät näy kuiteissa',
      tooltip: 'Kun käytössä, piilottaa juomarahat sekä tulostetuista kuiteista että tilaustietoikkunasta',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
